import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import EsconderSenhaIcone from '../../assets/Hide.svg';
import MostrarSenhaIcone from '../../assets/show.svg';
import LoginService from '../../service/login';
import AlterarSenhaService from '../../service/alterarSenha';
import { startTokenRefreshInterval } from '../../service/tokenRefresh';
import Api from '../../service';

const Container = styled.div.attrs({
  className: 'login-container'
})`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: rgba(7, 128, 128, 0.27);
`;

const ContainerCentral = styled.div.attrs({
  className: 'login-container-central'
})`
  width: 720px;
  height: 520px;
  display: flex;
  flex-direction: row;
  border-radius: 16px;
  overflow: visible; 
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  background-color: transparent; 
  position: relative;
  box-sizing: border-box;

  @media (max-width: 768px) {
    width: 90%;
    height: auto;
    flex-direction: column;
    max-width: 400px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  }
`;

const PainelEsquerdo = styled.div.attrs({
  className: 'login-painel-esquerdo'
})`
    flex: 1;
    background-color: rgb(0, 128, 128);
    display: flex;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    color: white;
    gap: 5px;
    border-radius: 16px 0px 0px 16px;
    margin-right: -8px;
    max-width: 350px; 

    @media (max-width: 768px) {
      margin-right: 0;
      margin-bottom: 0;
      border-radius: 16px 16px 0 0;
      max-width: 100%;
      width: 100%;
      padding: 40px 20px;
      box-sizing: border-box;
    }
`;

const LogoTexto = styled.div.attrs({
  className: 'login-logo-texto'
})`
  font-size: 3.5rem;
  font-weight: bold;
  font-family: 'Kadwa', sans-serif;
  letter-spacing: 2px;
  line-height: 1;
  display: inline-block;

  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

const SubtituloEsquerdo = styled.div.attrs({
  className: 'login-subtitulo-esquerdo'
})`
  font-size: 1.3rem;
  font-family: 'Kadwa', sans-serif;
  font-weight: 300;
  margin-top: 0;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const PainelDireito = styled.div.attrs({
  className: 'login-painel-direito'
})`
  flex: 1.2;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: stretch; 
  padding: 60px 50px;
  position: relative;
  z-index: 2; 
  border-radius: 16px;
  margin-left: -8px; 
  max-width: 380px; 

  @media (max-width: 768px) {
    margin-left: 0;
    border-radius: 0 0 16px 16px;
    padding: 30px 24px 40px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

const ConteudoDireito = styled.div.attrs({
  className: 'login-conteudo-direito'
})`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; 
  width: 100%;
  gap: 10px;
`;

const FormCentral = styled.form.attrs({
  className: 'login-form-central'
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 380px;
  gap: 15px;
`;

const InputWrapper = styled.div.attrs({
  className: 'login-input-wrapper'
})`
  position: relative;
  width: 100%;
  margin: 0; 
  display: flex;
  align-items: center;
`;

const Campo = styled.div.attrs({
  className: 'login-campo'
})`
  width: 100%;
`;

const Label = styled.label.attrs({
  className: 'login-label'
})`
  display: block;
  margin: 0 0 6px 6px; 
  color: #8E8E93;
  font-family: 'Roboto', sans-serif;
  font-size: 0.8rem;
  font-weight: 500;
`;

const InputIcon = styled.img.attrs({
  className: 'login-input-icon'
})`
  position: absolute;
  ${(props) => (!props.esconderSenha ? 'left: 12px' : 'right: 12px')};
  top: 50%;
  transform: translateY(-50%);
  width: ${(props) => (!props.esconderSenha ? '20px' : '20px')};
  height: ${(props) => (!props.esconderSenha ? '20px' : '20px')};
  opacity: 0.6;
  cursor: pointer;
`;

const Input = styled.input.attrs({
  className: 'login-input'
})`
  padding: 10px 36px 12px 16px; 
  width: 100%;
  border-radius: 12px;
  background-color: #DDE2E7; 
  border: 1px solid #E2E6EA;
  font-size: 0.8rem;
  outline: none;
  color: #8E8E93;
  font-family: 'Roboto', sans-serif;
  transition: border-color 0.2s, background-color 0.2s;
  box-sizing: border-box;

  &::placeholder {
    color: #A3ADB5;
  }

  &:focus {
    border-color: #158F8F;
    background-color: #F5F8FA;
  }

  @media (max-width: 768px) {
    padding: 14px 36px 14px 16px;
    font-size: 1rem;
  }
`;

const Titulo = styled.h2.attrs({
  className: 'login-titulo'
})`
  text-align: center;
  margin: 0 0 8px 0;
  font-family: 'Kadwa', sans-serif;
  color: #999;
  font-size: 0.85rem;
  font-weight: 600;
`;

const TituloLogin = styled.h1.attrs({
  className: 'login-titulo-login'
})`
  text-align: center;
  margin: 0;
  font-family: Roboto, sans-serif;
  color: rgb(88, 88, 91);
  font-size: 1.4rem;
  font-weight: 600;
`;

const Texto = styled.div.attrs({
  className: 'login-texto'
})`
  text-align: center;
  font-family: 'Roboto', sans-serif;
  color: #8E8E93;
  font-size: ${(props) => (props.pequeno ? '0.6rem' : '0.7rem')};
  padding: 0;
  line-height: 1.5;
`;

const TextoRodape = styled(Texto).attrs({
  className: 'login-texto-rodape'
})`
  margin-top: 20px;
`;

const TextoErro = styled(Texto).attrs({
  className: 'login-texto-erro'
})`
  color: #D32F2F;
`;

const Aviso = styled.div.attrs({
  className: 'login-aviso'
})`
  padding-bottom: 12px;
`;

const Button = styled.button.attrs({
  className: 'login-button'
})`
  width: ${(props) => (props.$large ? '200px' : '200px')};
  height: 35px;
  padding: 0 16px;
  border-radius: 10px;
  margin: 24px 0 5% 0;
  background-color: #008080;
  border: none;
  color: white;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.3s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-sizing: border-box;

  &:hover {
    background-color: #00AAAA;
  }

  &:active {
    background-color: #0F5F5F;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 48px;
    font-size: 1rem;
    margin-top: 32px;
  }
`;



const determinarPaginaInicial = async (perfis, idUsuario) => {
  if (perfis.includes('secretaria')) {
    try {
      const resp = await Api.get(`pontos/listarPontos?coordenadorId=${idUsuario}`);
      const pontos = Array.isArray(resp.data) ? resp.data : [];
      const temPontoEventos = pontos.some(p => String(p?.nome || '').trim().toLowerCase() === 'eventos');
      const temOutrosPontos = pontos.some(p => String(p?.nome || '').trim().toLowerCase() !== 'eventos');
      if (temPontoEventos && !temOutrosPontos) return '/eventos';
    } catch {}
  }
  return '/home';
};

const LoginPage = () => {
  const navigate = useNavigate();
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [mostrarConfirmarSenha, setMostrarConfirmarSenha] = useState(false);
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [erro, setErro] = useState('');
  const [modoAlterarSenha, setModoAlterarSenha] = useState(false);
  const [dadosUsuarioLogado, setDadosUsuarioLogado] = useState(null);

  React.useEffect(() => {
    window.history.replaceState(null, '', '/');
  }, []);

  const handleLogin = async () => {
    try {
      setErro('');
  
      const data = await LoginService.login(usuario, senha);
      console.log('Dados recebidos do login:', data);
  
      const perfisNaoPublicador = data?.perfil?.filter(perfil => perfil !== 'publicador') || [];

      if (perfisNaoPublicador.length === 0) {
        setErro('Acesso não permitido para publicadores');
        return;
      }

      // Limpa dados antigos para garantir uma sessão limpa
      const itemsToKeep = {};
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && (key.startsWith('hideWelcomeDialog_') || key.startsWith('hideNovidadesEventos_v1_'))) {
          itemsToKeep[key] = localStorage.getItem(key);
        }
      }
      
      localStorage.clear();
      
      Object.keys(itemsToKeep).forEach(key => {
        localStorage.setItem(key, itemsToKeep[key]);
      });

      localStorage.setItem('accessToken', data.accessToken);
      localStorage.setItem('idUsuario', data.idUsuario);
      localStorage.setItem('usuario', usuario);
      
      try {
        localStorage.setItem('perfilUsuario', JSON.stringify(data.perfil || []));
      } catch (e) {}
      
      if (data.primeiroAcesso) {
        localStorage.setItem('senhaTemporaria', 'true');
        localStorage.removeItem('senhaAlterada');
        setModoAlterarSenha(true);
        setDadosUsuarioLogado(data);
        setErro('');
      } else {
        localStorage.setItem('senhaAlterada', 'true');
        localStorage.removeItem('senhaTemporaria');
        
        // Timer removido pois será iniciado pelo App.js após o reload
        
        // Força recarregamento da página para limpar cache de memória e prevenir estados antigos
        const paginaInicial = await determinarPaginaInicial(data.perfil || [], data.idUsuario);
        window.location.href = paginaInicial;
      }
    } catch (error) {
      console.error('Erro no login:', error);
      setErro('Credenciais inválidas');
    }
  };

  const handleAlterarSenha = async () => {
    try {

      if (!novaSenha || !confirmarSenha) {
        setErro('Preencha todos os campos');
        return;
      }

      if (novaSenha.length < 6) {
        setErro('A nova senha deve ter pelo menos 6 caracteres');
        return;
      }

      if (novaSenha !== confirmarSenha) {
        setErro('As senhas não coincidem');
        return;
      }

      // if (novaSenha === data.senha) {
      //   setErro('A nova senha não pode ser igual à senha temporária');
      //   return;
      // }

    
      await AlterarSenhaService.alterarSenha(dadosUsuarioLogado.idUsuario, novaSenha);
      
      localStorage.setItem('senhaAlterada', 'true');
      localStorage.removeItem('senhaTemporaria');
      
      // Timer removido pois será iniciado pelo App.js após o reload
      
      // Força recarregamento da página
      const perfis = JSON.parse(localStorage.getItem('perfilUsuario') || '[]');
      const idUsuario = localStorage.getItem('idUsuario');
      const paginaInicial = await determinarPaginaInicial(perfis, idUsuario);
      window.location.href = paginaInicial;
      
    } catch (error) {
      console.error('Erro ao alterar senha:', error);
      setErro('Erro ao alterar senha. Tente novamente.');
    }
  };

  const alternarMostrarSenha = () => {
    setMostrarSenha((prev) => !prev);
  };

  const alternarMostrarConfirmarSenha = () => {
    setMostrarConfirmarSenha((prev) => !prev);
  };

  return (
    <Container>
      <ContainerCentral>
        <PainelEsquerdo>
          <LogoTexto>TPE</LogoTexto>
          <SubtituloEsquerdo>Distrito Federal</SubtituloEsquerdo>
        </PainelEsquerdo>
        
        <PainelDireito>
          <ConteudoDireito>
          {!modoAlterarSenha ? (
            <>
              <Titulo>Testemunho Público Especial - DF</Titulo>
              {/* <Titulo>Ambiente de Teste - Homologação</Titulo> */}
              <TituloLogin>LOGIN</TituloLogin>
              <Texto>Informe seus dados para acesso</Texto>
              
              <FormCentral onSubmit={e => { e.preventDefault(); handleLogin(); }}>
                <Campo>
                  <Label htmlFor="usuario">Usuário</Label>
                  <InputWrapper>
                    <Input
                      id="usuario"
                      type="text"
                      placeholder="Digite seu usuário aqui"
                      value={usuario}
                      onChange={(e) => setUsuario(e.target.value)}
                    />
                  </InputWrapper>
                </Campo>

                <Campo>
                  <Label htmlFor="senha">Senha</Label>
                  <InputWrapper>
                    <Input
                      id="senha"
                      type={mostrarSenha ? 'text' : 'password'}
                      placeholder="Digite sua senha aqui"
                      value={senha}
                      onChange={(e) => setSenha(e.target.value)}
                    />
                    <InputIcon
                      esconderSenha
                      src={mostrarSenha ? MostrarSenhaIcone : EsconderSenhaIcone}
                      alt={mostrarSenha ? "Esconder senha" : "Mostrar senha"}
                      onClick={alternarMostrarSenha}
                    />
                  </InputWrapper>
                </Campo>
                
                {erro && <TextoErro pequeno>{erro}</TextoErro>}
                
                <Button type="submit">ENTRAR</Button>
              </FormCentral>
            </>
          ) : (
            <>
              <Titulo>Testemunho Público Especial - DF</Titulo>
              <TituloLogin>ALTERAR SENHA</TituloLogin>
              <Aviso>
                <Texto>Você está usando uma senha temporária</Texto>
                <Texto>Para sua segurança, é obrigatório criar uma nova senha</Texto>
              </Aviso>
              
              <FormCentral onSubmit={e => { e.preventDefault(); handleAlterarSenha(); }}>
                <Campo>
                  <Label htmlFor="novaSenha">Nova Senha</Label>
                  <InputWrapper>
                    <Input
                      id="novaSenha"
                      type={mostrarSenha ? 'text' : 'password'}
                      placeholder="Nova Senha"
                      value={novaSenha}
                      onChange={(e) => setNovaSenha(e.target.value)}
                    />
                    <InputIcon
                      esconderSenha
                      src={mostrarSenha ? MostrarSenhaIcone : EsconderSenhaIcone}
                      alt={mostrarSenha ? "Esconder senha" : "Mostrar senha"}
                      onClick={alternarMostrarSenha}
                    />
                  </InputWrapper>
                </Campo>

                <Campo>
                  <Label htmlFor="confirmarSenha">Confirmar Nova Senha</Label>
                  <InputWrapper>
                    <Input
                      id="confirmarSenha"
                      type={mostrarConfirmarSenha ? 'text' : 'password'}
                      placeholder="Confirmar Nova Senha"
                      value={confirmarSenha}
                      onChange={(e) => setConfirmarSenha(e.target.value)}
                    />
                    <InputIcon
                      esconderSenha
                      src={mostrarConfirmarSenha ? MostrarSenhaIcone : EsconderSenhaIcone}
                      alt={mostrarConfirmarSenha ? "Esconder senha" : "Mostrar senha"}
                      onClick={alternarMostrarConfirmarSenha}
                    />
                  </InputWrapper>
                </Campo>
                
                {erro && <TextoErro pequeno>{erro}</TextoErro>}
                
                <Button type="submit" $large>ALTERAR SENHA</Button>
              </FormCentral>
            </>
          )}
          
          <TextoRodape pequeno>
            Este não é um site oficial das Testemunhas de Jeová.
          </TextoRodape>
          </ConteudoDireito>
        </PainelDireito>
      </ContainerCentral>
    </Container>
  );
};

export default LoginPage;
